import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MaskType } from "src/app/constants/masks";
import { directDepositType } from "src/app/constants/direct-deposit";
import { DirectDepositModel } from "src/app/models/payroll";
import { PayrollService } from "src/app/services/payroll.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-direct-deposit-form',
    templateUrl: './direct-deposit-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollDirectDepositFormComponent implements OnInit {
    @Input() public title: string;
    @Input() public directDeposit: DirectDepositModel;
    @Input() isEditing: boolean;

    @Output() public cancelEmit: EventEmitter<DirectDepositModel> = new EventEmitter<DirectDepositModel>();

    public maskNumericType: MaskType;
    public directDepositForm: FormGroup;
    public lastUpdatedOn: string;
    public directDepositTypes = directDepositType;
    public errorMessage: string;
    
    constructor(
        private payrollService: PayrollService,
        private helperService: HelperService,
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.maskNumericType = this.isEditing ? MaskType.numericValues : MaskType.none;

        this.directDepositForm = this.formBuilder.group({
            paymentOptionTypeId: [{ value: this.directDeposit.paymentOptionTypeId.toString(), disabled: !this.isEditing }, Validators.required],
            bankName: [{ value: this.directDeposit.bankName, disabled: !this.isEditing }, Validators.required],
            routingNumber: [{ value: this.directDeposit.routingNumber, disabled: !this.isEditing }, Validators.required],
            accountNumber: [{ value: this.directDeposit.accountNumber, disabled: !this.isEditing }],
            accountNumberForValidation: [{ value: this.directDeposit.accountNumberForValidation, disabled: !this.isEditing }, Validators.required],
        });
    }

    public save(): void {
        this.errorMessage = null;
        const l_payload: DirectDepositModel = this.helperService.convertFormGroupIntoObject(this.directDepositForm, new DirectDepositModel());
        this.payrollService.saveDirectDeposit(l_payload).subscribe((response: DirectDepositModel) => {
            if(response.errorMessage)
                this.errorMessage = response.errorMessage;
            else
                this.cancelEmit.emit(response);
        });
    }

    public cancel() {
        this.cancelEmit.emit();
    }
}
